import { render, staticRenderFns } from "./GoodDesignAwardForm.vue?vue&type=template&id=2a0e5224"
import script from "./GoodDesignAwardForm.vue?vue&type=script&lang=js"
export * from "./GoodDesignAwardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a0e5224')) {
      api.createRecord('2a0e5224', component.options)
    } else {
      api.reload('2a0e5224', component.options)
    }
    module.hot.accept("./GoodDesignAwardForm.vue?vue&type=template&id=2a0e5224", function () {
      api.rerender('2a0e5224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/good-design-award/components/GoodDesignAwardForm.vue"
export default component.exports